/* 统一表单配置 */
// import Vue from "vue/types/vue";
import Vue from 'vue'
export const formConfig= {
    layout: 'vertical',
    // hideRequiredMark: true,
};
/* 统一Modal弹窗配置 */
export const modalConfig = {
    width: '90%',
    destroyOnClose: true,
};
/* 统一抽屉配置 */
export const drawerConfig = {
    width: 720,
    maskClosable:false,
    destroyOnClose: true
}
/* 关闭Modal时清除表单内容 */
export const closeModal = (onCancel, form) => {
    onCancel();
    form.resetFields();
};
/* 栅格表单 */
export const formColConfig = {
    lg: 8,
    md: 12,
    xxl: 6,
    xl: 8,
    sm: 12,
    xs: 24,
};
/* 提交表单封装 */
let stopClick=true
export const submitForm = async (run, params) => {
    if(stopClick==true){
        stopClick=false
    setTimeout(()=>{
        stopClick=true
    },1500)
    let submitKey = 'submitupdatable';
    // let hide = Vue.prototype.$message.loading({content:'正在提交', duration: 0,key:submitKey} )
    try {
        // hide();
        const res = await run(params);
        if (res.data.code === 200) {
            Vue.prototype.$message.success({ content:res.data.msg, key:submitKey , duration: 2 })
            return true;
        }
        if (res.data.code === 400) {
            // Vue.prototype.$message.error({ content:"提交失败,请重试！", key:submitKey, onClose })
            Vue.prototype.$message.destroy()
            return res.data.msg;
        }
        return false;
    } catch (error) {
        // hide();
        Vue.prototype.$message.error('提交失败,请重试！')
        return false;
    }
    }else{
        return []
    }
};
export const removeById = async (run, params) => {
    let removeKey = 'removetable';
    let hide = Vue.prototype.$message.loading({content:'正在删除',key:removeKey} )
    try {
        hide();
        const res = await run(params);
        if (res.data.code === 200) {
            Vue.prototype.$message.success({ content:res.data.msg, key:removeKey, duration: 2 })
            return true;
        }
        if (res.data.code === 500) {
            Vue.prototype.$message.destroy()
            Vue.prototype.$message.error({ content:res.data.msg, key:removeKey, duration: 2 })
        }
        return false;
    } catch (error) {
        // hide();
        console.log(error)
        Vue.prototype.$message.error('删除失败,请重试！')
        return false;
    }
};
export const changStatus = async (run, params) => {
    let changKey = 'updatable';
    let hide = Vue.prototype.$message.loading({content:'正在修改',key:changKey} )
    try {
        hide();
        const res = await run(params);
        if (res.data.code === 200) {
            Vue.prototype.$message.success({ content:res.data.msg, key:changKey, duration: 2 })
            return true;
        }
        if (res.data.code === 400) {
            Vue.prototype.$message.error({ content:"修改失败,请重试！", key:changKey, duration: 2 })
            return res.data.msg;
        }
        return false;
    } catch (error) {
        hide();
        Vue.prototype.$message.error('修改失败,请重试！')
        return false;
    }
};

export const orderList = async (run, params) => {
    let orderKey = 'updatable';
    console.log(params)
    let check=0
    params.forEach((item,index)=>{
        if(item.list_order*1<0){
            Vue.prototype.$message.error('排序值需大于零', 1 )
            check=1
        }
    })
    if(check==1)return
    let hide = Vue.prototype.$message.loading({content:'正在排序',key:orderKey} )
    try {
        hide();
        const res = await run(params);
        if (res.data.code === 200) {
            Vue.prototype.$message.success({ content:res.data.msg, key:orderKey, duration: 2 })
            return true;
        }
        if (res.data.code === 400) {
            Vue.prototype.$message.error({ content:"排序失败,请重试！", key:orderKey, duration: 2 })
            return res.data.msg;
        }
        return false;
    } catch (error) {
        hide();
        Vue.prototype.$message.error('排序失败,请重试！')
        return false;
    }
};

/* 后台返回错误验证信息展示*/
export const validator=(rule, value, callback,errval)=> {
    let formerrname=rule.field
    if( errval!=""){
        callback(new Error(errval))
    }  else{callback();}
}
/* 验证上传文件类型 */
export const beforeUpload = (file,num=2) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        Vue.prototype.$message.error('只能上传 JPG/PNG 文件!');
        return false
    }
    const isLt2M = file.size / 1024 / 1024 < num;
    if (!isLt2M) {
        Vue.prototype.$message.error(`文件必须小于${num}MB!`);
        return false
    }
    return new Promise(function (resolve,reject) {
        resolve(file)
    })
};
/* 导出文件流 */
export const handleExport = async (res, fileName) => {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.download = fileName;
    a.href = window.URL.createObjectURL(res);
    a.click();
    // document.body.removeChild(a)
    message.success('导出成功');
};

export const checkUrl=(rule, value, callback,errval)=> {
    let formerrname=rule.field
    var test = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
    if( errval!=""){
        callback(new Error(errval))
    } else if(value!=""&&!test.test(value) ){
        callback(new Error("请输入正确网址"))
    } else{   callback();}
}
export const debounce=(fn, time)=> {
    time = time || 200
    // 定时器
    let timer = null
    return function(...args) {
        var _this = this
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(function() {
            timer = null
            fn.apply(_this, args)
        }, time)
    }
}
